import { useEffect } from "react";

export default function SubmithubAlternative() {
  useEffect(() => {
    // SEO Meta tags
    const title = "2025 SubmitHub Alternative: Soundope is Cheaper, 100% Real Curators, No Bots";
    document.title = title;

    const description =
      "Soundope is the 2025 SubmitHub alternative with $1 submissions, $5 minimum, 100% human curators, guaranteed honest feedback, and a free tier to try before you buy.";

    const metaTags = [
      { type: "name", key: "description", content: description },
      {
        type: "name",
        key: "keywords",
        content:
          "submithub alternative, cheaper than submithub, playlist submission, independent artist promotion, real curators, no bots, free playlist submissions",
      },
      { type: "name", key: "robots", content: "index, follow" },

      // Open Graph
      { type: "property", key: "og:title", content: title },
      { type: "property", key: "og:description", content: description },
      { type: "property", key: "og:type", content: "website" },
      { type: "property", key: "og:url", content: window.location.href },

      // Twitter
      { type: "name", key: "twitter:card", content: "summary_large_image" },
      { type: "name", key: "twitter:title", content: title },
      { type: "name", key: "twitter:description", content: description },

      // Canonical URL
      {
        type: "link",
        key: "canonical",
        content: window.location.origin + "/submithub-alternative",
      },
    ];

    metaTags.forEach(({ type, key, content }) => {
      if (type === "link") {
        let tag = document.querySelector(`link[rel="${key}"]`);
        if (tag) {
          tag.setAttribute("href", content);
        } else {
          tag = document.createElement("link");
          tag.setAttribute("rel", key);
          tag.setAttribute("href", content);
          document.head.appendChild(tag);
        }
      } else {
        const selector =
          type === "property"
            ? `meta[property="${key}"]`
            : `meta[name="${key}"]`;
        let tag = document.querySelector(selector);

        if (tag) {
          tag.setAttribute("content", content);
        } else {
          tag = document.createElement("meta");
          tag.setAttribute(type, key);
          tag.setAttribute("content", content);
          document.head.appendChild(tag);
        }
      }
    });
  }, []);

  return (
    <div className="min-h-screen px-4 py-16 pb-32 bg-[#050505]">
      <div className="max-w-3xl mx-auto">
        <h1 className="text-3xl md:text-4xl font-light mb-6 text-[#f5f5f5]">
          Soundope: The Best SubmitHub Alternative in 2025
        </h1>

        <p className="text-base md:text-lg text-[#bbbbbb] mb-4">
          Tired of SubmitHub’s $2–$6 credits, fake “premium” curators, botted
          playlists, and zero guaranteed feedback?
        </p>

        <p className="text-base md:text-lg text-[#bbbbbb] mb-4">
          Soundope fixes everything SubmitHub gets wrong:
        </p>

        <ul className="list-disc list-inside space-y-2 text-[#d0d0d0] mb-6">
          <li>$1 submissions ($5 min) — literally half SubmitHub&apos;s price</li>
          <li>100% human curators — zero bots, zero fake streams</li>
          <li>Honest feedback on every single track — guaranteed</li>
          <li>Curators keep 80% — $0.80–$3.20 per submission, still one of the highest payouts in the game</li>
          <li>Free tier available — try before you buy</li>
        </ul>

        <p className="text-base md:text-lg text-[#bbbbbb] mb-4">
          SubmitHub charges you $10–$20 just to get ignored by botted playlists.
          Soundope charges $5 and actually gets your music heard by real Spotify
          &amp; Apple Music curators.
        </p>

        <p className="text-base md:text-lg text-[#dcdcdc] font-medium mb-6">
          <strong>Join the thousands of artists who left SubmitHub in 2025.</strong>
        </p>

        <a
          href="/signup"
          className="inline-block px-6 py-3 rounded-full bg-[#b61f3d] text-white text-sm md:text-base font-semibold tracking-wide hover:bg-[#e0254c] transition-colors"
        >
          Start Free — Better Than SubmitHub
        </a>

        <div className="mt-4">
          <a
            href="/Upload"
            className="inline-block px-6 py-3 rounded-full bg-transparent border border-[#b61f3d] text-[#f5f5f5] text-sm md:text-base font-semibold tracking-wide hover:bg-[#b61f3d] hover:text-white transition-colors"
          >
            Upload a track now
          </a>
        </div>
      </div>
    </div>
  );
}


